import { useQuery } from 'urql';
import { Query, QueryStructureArgs, QueryStructuresArgs, Structure } from 'api';
import { GET_STRUCTURE_CHILDREN } from 'api/graphql/queries/structure';
import { usePagination } from 'api/graphql/helpers/usePagination';
import { useEffect, useState } from 'react';
import { paginationLastPage } from 'utils/paginationLastPage';

export type QueryType = Pick<Query, 'structure'>;

type Args = QueryStructuresArgs & QueryStructureArgs;

export const useGetStructureChildren = (variables: Args) => {
    const [isLoading, setIsLoading] = useState(true);
    const [page, setPage] = useState(1);

    const shouldPause = !variables.id || variables.id === '';

    const [{ fetching, data, error }, reexecuteQuery] = useQuery<QueryType>({
        query: GET_STRUCTURE_CHILDREN,
        variables: {
            ...variables,
            page,
        },
        pause: shouldPause,
        requestPolicy: 'network-only',
    });

    const lastPage = paginationLastPage(data?.structure.children.totalCount, variables.perPage);

    useEffect(() => {
        if (data) {
            if (page < lastPage) {
                setPage(page + 1);
            } else {
                setIsLoading(false);
            }
        }
    }, [data]);

    const { paginationData } = usePagination<Structure, QueryType>({
        data,
        page,
        fetching,
        nodes: data?.structure?.children.nodes,
        id: variables.id,
    });

    return { fetching, data, error, reexecuteQuery, paginationData, isLoading };
};
